import Component from 'Component';
import OneButton from "./player/OneButton";
import Standalone from "./player/Standalone";
import Engine from "./player/Engine";

export default class Player extends Component {

  _namespace = this.constructor.name;

  _components = [
    new Engine(this.App, this._namespace),
    new OneButton(this.App, this._namespace),
    new Standalone(this.App, this._namespace),
    /*new Login(this.App, this._namespace),
    new MagicLink(this.App, this._namespace),
    new PasswordReset(this.App, this._namespace),*/
  ];

  configure() {

    this.components.forEach((component) => {
      let name = component.constructor.name;
      this[name] = component.configure().initialize();
    });

    return super.configure();
  }

  get components() {
    return this._components;
  }

  initialize() {
    return super.initialize();
  }

}